import { faqs } from "../data"
import FAQ from "./FAQ"

const FAQs = () => {
  return (
    <section id="faqs" className="faqs">
      <div className="container">
        <div className="faqs__header">
          <p className="faqs__eyebrow">Questions</p>
          <h2 className="faqs__title">Frequently asked</h2>
        </div>
        <div className="faqs__wrapper">
          {faqs.map(({id, question, answer}) => (
            <FAQ key={id} question={question} answer={answer} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQs
